import React, { useState } from 'react'
import { Box, CircularProgress, Divider, Typography } from '@mui/material'
import Button from 'components/Button'
import Tag from 'components/Tag'
import CustomTable from 'components/Table'
import { Link, useNavigate } from 'react-router-dom'
import CustomSelect from 'components/CustomSelect'
import { translation } from 'utils/germanTranslation'
import NothingToShow from '../NothingToShow'
import ZoomInstructionsButton from 'components/ZoomInstructionsButton'
import ZoomInstructionsModal from 'components/ZoomInstructionsModal'

const DetailPageWithTable = ({
  pageTitle,
  buttons,
  loading,
  rows,
  HeaderTemplate,
  rowTemplate,
  sortingOptions = [],
  sortBy,
  handleSortBy,
  AddButton,
  emptyPageMessage,
  titleIcon,
  showZoomInstructions = true,
  isClassTeacher = false,
  banner = null
}) => {
  const navigate = useNavigate()
  const [showInstructionsModal, setShowInstructionsModal] = useState(false)

  return (
    <Box className='max-w-[1760px] m-auto px-4 sm:px-8 w-full py-10 bg-softWhite min-h-screen text-softBlack'>
      <Box className='flex flex-col xs:flex-row items-start xs:items-stretch gap-6 xs:gap-[5%] mb-10'>
        <Box className='flex flex-col justify-between items-start w-full md:w-1/2'>
          <Typography className='font-bold text-3xl flex items-center gap-5'>
            <span>
              {pageTitle}{' '}
              <span className='opacity-30'>({!loading && rows.length})</span>
            </span>
            {titleIcon}
          </Typography>
          <div className='flex flex-col xs:flex-row items-center xs:items-end justify-center xs:justify-start gap-4 xs:gap-6 w-full xs:w-auto pt-4'>
            {buttons.map((button, index) => (
              <div key={index} className='w-full xs:w-auto'>
                {button.link ? (
                  <Link to={button.link}>
                    <Button key={index} {...button} />
                  </Link>
                ) : (
                  button
                )}
              </div>
            ))}
            <div className='w-full xs:w-auto'>
              <Button
                title={translation.back}
                titleClasses='text-[#458EFF] font-semibold'
                containerClasses='bg-[#E9F1FC] w-full md:w-[200px] min-w-[7rem] h-[56px] rounded-md'
                onClick={() => navigate(-1)}
              />
            </div>
          </div>
        </Box>

        {banner}
      </Box>
      {sortingOptions.length ? (
        <div className='flex items-center justify-between gap-4 w-full mt-4'>
          <div className='w-full sm:w-56 flex items-center'>
            <span className='w-full'>{translation.sortBy}:</span>
            <CustomSelect
              options={sortingOptions}
              value={sortBy}
              handleChange={handleSortBy}
              disabled={loading || !rows.length}
            />
          </div>
          {!isClassTeacher && showZoomInstructions && (
            <div className='hidden md:block md:ml-auto w-28'>
              <ZoomInstructionsButton
                containerClasses=''
                onClick={() => setShowInstructionsModal(true)}
              />
            </div>
          )}
        </div>
      ) : (
        ''
      )}
      <div className='mt-4'>
        {rows.length ? (
          <CustomTable
            loading={loading}
            data={rows}
            headerTemplate={<HeaderTemplate />}
            rowTemplate={(row, index) => rowTemplate(row, index)}
          />
        ) : loading ? (
          <div className='flex items-center justify-center h-screen'>
            <CircularProgress />
          </div>
        ) : (
          <NothingToShow title={emptyPageMessage} />
        )}
        {!isClassTeacher && AddButton}
      </div>
      <ZoomInstructionsModal
        showInstructionsModal={showInstructionsModal}
        setShowInstructionsModal={setShowInstructionsModal}
      />
    </Box>
  )
}

export default DetailPageWithTable
